import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  SkyResourcesModule
} from '../resources';

import { SkyTokenComponent } from './token.component';
import { SkyTokensComponent } from './tokens.component';


export class SkyTokensModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkyTokenComponent,
    SkyTokensComponent
  ],
  imports: [
    CommonModule,
    SkyResourcesModule
  ],
  exports: [
    SkyTokenComponent,
    SkyTokensComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
